import * as a from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/HandPalm.es.js";
const o = a.forwardRef((m, e) => /* @__PURE__ */ a.createElement(r, { ref: e, ...m, weights: t }));
o.displayName = "HandPalmIcon";
const s = o;
export {
  s as HandPalm,
  o as HandPalmIcon
};
